import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowReferenceSet } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type RoleViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  name_esValue?: { displayId: string; id: string } | null;
  name_es: string;
  name_enValue?: { displayId: string; id: string } | null;
  name_en: string;
  name_ptValue?: { displayId: string; id: string } | null;
  name_pt: string;
  permissionsValues: { displayId: string; id: string }[];
  audienceValue?: { displayId: string; id: string } | null;
  audience: string;
  isForAllTenantsValue?: { displayId: string; id: string } | null;
  isForAllTenants: boolean;
};

export const RoleViewForm: React.FC<RoleViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name_es = "",
    name_en = "",
    name_pt = "",
    permissionsValues,
    audience = "",
    isForAllTenants = false,
  }) => {
    const rootStore = useRootStore();
    const { authStore, langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupRoleLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={name_es}
                label={langStore.RoleNameLabel + " (es)"}
              />
              ,
              <ShowMultiLine
                value={name_en}
                label={langStore.RoleNameLabel + " (en)"}
              />
              ,
              <ShowMultiLine
                value={name_pt}
                label={langStore.RoleNameLabel + " (pt)"}
              />
              <ShowReferenceSet
                label={langStore.RolePermissionsLabel}
                selectedValues={permissionsValues}
              />
              {["SysAdmin"].some((role) => authStore.hasRole(role)) && (
                <ShowMultiLine
                  value={audience}
                  label={langStore.RoleAudienceLabel}
                />
              )}
              <ShowBoolean
                value={isForAllTenants}
                label={langStore.RoleIsForAllTenantsLabel}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
